import { render, staticRenderFns } from "./BubleChat.vue?vue&type=template&id=cd857988&scoped=true&"
import script from "./BubleChat.vue?vue&type=script&lang=js&"
export * from "./BubleChat.vue?vue&type=script&lang=js&"
import style0 from "./BubleChat.vue?vue&type=style&index=0&id=cd857988&prod&lang=sass&"
import style1 from "./BubleChat.vue?vue&type=style&index=1&id=cd857988&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd857988",
  null
  
)

export default component.exports